//TODO: use information from the backend
export const vesselsTRACOS = ["MV34", "MV51"];

export const MLSS_VESSEL_ID = "MLSS";
export const CTO_DATE_SELECTION_DEFAULT_MAX_DAYS = 90;
export const CTO_DATE_SELECTION_EXTENDED_MAX_DAYS = 365;

export type CtoDateSelectionMaxDays =
  | typeof CTO_DATE_SELECTION_DEFAULT_MAX_DAYS
  | typeof CTO_DATE_SELECTION_EXTENDED_MAX_DAYS;

export const resolveCtoDateSelectionMaxDays = (
  vesselId: string | null | undefined,
  extendedRangeEnabled: boolean,
): CtoDateSelectionMaxDays =>
  extendedRangeEnabled && vesselId === MLSS_VESSEL_ID
    ? CTO_DATE_SELECTION_EXTENDED_MAX_DAYS
    : CTO_DATE_SELECTION_DEFAULT_MAX_DAYS;

export const vesselsWithMopo = [MLSS_VESSEL_ID];

export const vesselsAllowedForNewBarriersLayout = ["UARU"];
